import { Component, DoCheck, ElementRef, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { faUpload } from '@fortawesome/free-solid-svg-icons';
import { ToastrService } from 'ngx-toastr';
import { fadeIn } from 'src/app/animations';
import { Md5 } from 'ts-md5';
@Component({
  selector: 'form-input',
  templateUrl: './form-input.component.html',
  styleUrls: ['./form-input.component.css'],
  animations: [fadeIn]
})
export class FormInputComponent implements DoCheck {
  @ViewChild('fileInput') fileInput!: ElementRef;
  @Input() labelInput!: String;
  @Input() tipoDocumento!: any;
  @Input() formFiles!: any;
  @Input() isRequired!: Boolean;
  @Input() isMultiple!: Boolean;
  @Input() errorRequired!: any;
  @Output('adicionar') adicionarArquivo: EventEmitter<any> = new EventEmitter<File>();
  constructor(private toast: ToastrService) { }
  excededMaxFileSize: boolean = false;
  //variaveis local
  mensagemInvalido: String = 'Por favor, selecione um arquivo';
  formularioInvalido: any = false;
  tipoDocumentoAnterior!: String;
  icone = faUpload;
  async onFileSelected(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement?.files && inputElement.files.length > 0) {
      this.onFileChangeMax(inputElement.files).then(
        (result: any) => {
          if (result == null) {
            this.toast.error('Não é possível abrir este arquivo! Algo deu errado!');
          } else {
            this.adicionarArquivo.emit(result);
          }
        }
      );
      this.formularioInvalido = false;
    } else {
      this.formularioInvalido = true;
    }
  }
  async closeOption(event: Event) { }
  async onFileChangeMax(files: FileList): Promise<any> {
    const maxSize = 1048576 * 25;
    let actualSize = 0;
    let olderSize = 0;
    let filesList64: any[] = [];
    let formFiles = this.formFiles;
    for (let index = 0; index < files.length; index++) {
      const element = files[index];
      if (element.size == 0) {
        this.toast.error('file:' + element);
        return null;
      }
      let md5 = new Md5();
      let byteArrray = await toByteArray(element);
      md5.appendByteArray(new Uint8Array(byteArrray as ArrayBuffer));
      let base64 = await toBase64(element);
      filesList64.push({ file: base64?.toString().split(",")[1], fileName: element.name, size: element.size / 1024, MD5: md5.end(), contentType: files[index].type });
      actualSize += element.size;
    }
    if (formFiles) {
      formFiles.forEach((a: any) => {
        olderSize += a.size * 1024
        let duplicatedFileIndex = filesList64.findIndex((newfile: any) => newfile.fileName === a.fileName && newfile.size === a.size);
        if (duplicatedFileIndex > -1) {
          actualSize -= (filesList64[duplicatedFileIndex].size * 1024)
          filesList64.splice(duplicatedFileIndex, 1);
          this.toast.error('Esse arquivo já foi adicionado em sua lista!');
        }
      });
      formFiles = this.formFiles.concat(filesList64);
    } else {
      formFiles = filesList64;
    }
    if ((actualSize + olderSize) > maxSize) {
      this.excededMaxFileSize = true;
      return false;
    }
    return formFiles;
  }
  ngDoCheck(): void { }
  ngOnChanges(changes: SimpleChanges) {
    if (changes["formFiles"]) { }
    // this.formularioInvalido = changesformAlertRequired;
  }
}
const toBase64 = (file: any) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result);
  reader.onerror = error => reject(error);
});
const toByteArray = (file: any) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsArrayBuffer(file);
  reader.onload = () => resolve(new Uint8Array(reader.result as ArrayBuffer));
  reader.onerror = error => reject(error);
});
